// Importing loadable for code-splitting
import loadable from "@loadable/component";

// Loadable components for various UI elements

// Input component
export const Input = loadable(() => import("./Input/index.ant"));

// Button component
export const Button = loadable(() => import("./Button/index.ant"));

// Form component
export const Form = loadable(() => import("./Form/index.ant"));

// Loader component
export const Loader = loadable(() => import("./Loader/index.ant"));

// Table component
export const Table = loadable(() => import("./Table/index.ant"));

// Modal component
export const Modal = loadable(() => import("./Modal/Modal"));

// OpenNotification component
export const OpenNotification = loadable(() => import("./Alerts/index.ant"));

// Password component
export const Password = loadable(() => import("./Password/index.ant"));

// Card component
export const Card = loadable(() => import("./Card/index.ant"));

// Layout component
export const Layout = loadable(() => import("./Layout/index.ant"));

// Sider component
export const Sider = loadable(() => import("./Sider/index.ant"));

// Content component
export const Content = loadable(() => import("./Content/index.ant"));

// Menu component
export const Menu = loadable(() => import("./Menu/index.ant"));

// SearchButton component
export const SearchButton = loadable(() => import("./Search/index.ant"));

// AntBreadcrumb component
export const AntBreadcrumb = loadable(() => import("./Breadcrumb/index.ant"));

// AntDropdown component
export const AntDropdown = loadable(() => import("./Dropdown/index.ant"));

// AntSelect component
export const AntSelect = loadable(() => import("./Select/index.ant"));

// AntTextArea component
export const AntTextArea = loadable(() => import("./TextArea/index.ant"));

// Rate component
export const Rate = loadable(() => import("./Rate/index.ant"));

// Checkbox component
export const Checkbox = loadable(() => import("./Checkbox/index.ant"));

// AntRadio component
export const AntRadio = loadable(() => import("./Radio/index.ant"));

// Confirm component
export const Confirm = loadable(() => import("./ConfirmPopup/index.ant"));

// Popovers component
export const Popovers = loadable(() => import("./Popover/index.ant"));

// DatePicker component
export const DatePicker = loadable(() => import("./DatePicker/index.ant"));

// Switch component
export const Switch = loadable(() => import("./Switch/index.ant"));

// AntTooltip component
export const AntTooltip = loadable(() => import("./Tooltip/index.ant"));

// Description component
export const Description = loadable(() => import("./Description/index.ant"));

// Upload component
export const Upload = loadable(() => import("./Upload/index.ant"));

// Select component
export const Select = loadable(() => import("./Select/index.ant"));

// MultiUpload component
export const MultiUpload = loadable(() => import("./MultiUpload/index.ant"));

// CheckboxGroup component
export const CheckboxGroup = loadable(() =>
  import("./CheckboxGroup/index.ant")
);

// AntCalendar component
export const AntCalendar = loadable(() => import("./Calendar/index.ant"));

// RangeSlider component
export const RangeSlider = loadable(() => import("./RangeSlider/index.ant"));

// DocumentUploader component
export const DocumentUploader = loadable(() => import("./Upload/index.ant"));

// CustomCheckbox component
export const CustomCheckbox = loadable(() => import("./CustomCheck/index.ant"));

// AntRangePicker component
export const AntRangePicker = loadable(() => import("./RangePicker/index.ant"));
